import React, { useContext, useState, useEffect } from "react";
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  Edit,
  ExcelExport,
  Filter,
  GridComponent,
  Inject,
  Page,
  PdfExport,
  Toolbar,
  ContextMenu,
  Sort,
} from "@syncfusion/ej2-react-grids";
import { PdfTrueTypeFont } from "@syncfusion/ej2-pdf-export";
import datagridContext from "../Context/datagridContext";
import "./Component.css";
import { useTranslation } from "react-i18next";
import font from "../Config/arial";
import { DataManager } from "@syncfusion/ej2-data";
import CustomAdaptor from "../Utils/CustomAdaptor.js";
import ToastContext from "../Context/toastContext.js";
import usePhoneNumberIdUpdater from "../Hooks/usePhoneNumberIdUpdater.js";
import { isUndefined } from "@syncfusion/ej2-base";

const Datagrid = ({ columns, onSelectionChange }) => {
  const { editSettings, toolbar, url, from, setStatus, headerQuery } =
    useContext(datagridContext);

  const { showToast } = useContext(ToastContext);
  const phoneNumberIdUpdater = usePhoneNumberIdUpdater();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  let isLoaded = false;
  let grid;
  const { t } = useTranslation();
  const filterSettings = { mode: "Immediate", immediateModeDelay: 500 };
  
  const sortSettings = {
    columns: [
      { field: "timestamp", direction: "Descending" }, // timestamp ile azalan sıralama
    ],
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toolbarClick = (args) => {
    if (grid) {
      if (args.item.id === "adaptivebrowser_pdfexport") {
        const originalWidth = grid.element.style.width;
        grid.element.style.width = "397mm";

        const exportableColumns = grid.columns.filter((col) => col.field);
        grid.pdfExport({
          columns: exportableColumns,
          pageOrientation: "Landscape",
          pageSize: "A4",
          theme: {
            header: {
              font: new PdfTrueTypeFont(font, 8),
            },
            caption: {
              font: new PdfTrueTypeFont(font, 6),
            },
            record: {
              font: new PdfTrueTypeFont(font, 6),
            },
          },
        });
        grid.pdfExportComplete = () => {
          grid.element.style.width = originalWidth; // Eski genişliğe geri dönüyoruz
        };
      } else if (args.item.id === "adaptivebrowser_excelexport") {
        grid.excelExport();
      } else if (args.item.id === "adaptivebrowser_csvexport") {
        grid.csvExport();
      }

      if (args.item.id === "adaptivebrowser_SendMessage") {
        window.location.href = "/sendmessage";
      }
    } else {
      console.error("Grid reference is not available.");
    }
  };

  const actionBegin = (args) => {
    // console.log(
    //   "actionBegin: ",
    //   args.action,
    //   " reqType: ",
    //   args.requestType,
    //   " cur: ",
    //   args.currentPage,
    //   " prev: ",
    //   args.previousPage,
    //   " args:",
    //   args.currentFilterObject?.field,
    //   args.currentFilterObject?.value
    // );
  };

  const actionComplete = (args) => {
    // console.log(
    //   "actionComplete: ",
    //   args.action,
    //   " reqType: ",
    //   args.requestType,
    //   " cur: ",
    //   args.currentPage,
    //   " prev: ",
    //   args.previousPage
    // );

    if (args.requestType === "delete") {
      showToast(`${t("Deleted successfully!")}`, `${t("Success")}`);
    }
    if (args.action === "add" && args.requestType === "save") {
      if (from === "Accounts") {
        let idUpdateData = args.data;
        if (isUndefined(args.data.id)) idUpdateData = args.rows[0].data;

        phoneNumberIdUpdater(idUpdateData);
      }
      showToast(`${t("Added successfully!")}`, `${t("Success")}`);
    }
    if (args.action === "edit" && args.requestType === "save") {
      if (from === "Accounts") phoneNumberIdUpdater(args.data);

      showToast(`${t("Updated successfully!")}`, `${t("Success")}`);
    }
  };

  const sendMessageToolbar = () => {
    let test = document.getElementById("adaptivebrowser_SendMessage");
    if (test) {
      test.innerHTML = "";

      const iconSpan = document.createElement("span");
      iconSpan.classList.add("e-btn-icon", "e-send", "e-icons", "e-icon-left");

      const textSpan = document.createElement("span");
      textSpan.classList.add("e-tbar-btn-text");
      textSpan.textContent = t("SendMessage");

      test.appendChild(iconSpan);
      test.appendChild(textSpan);
    }
  };

  const load = () => {
    if (isMobile && grid && !isLoaded) {
      isLoaded = true;

      grid.adaptiveDlgTarget =
        document.getElementsByClassName("e-mobile-content")[0];
    }
  };
 
  useEffect(() => {
    sendMessageToolbar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  const divStyle = {
    display: "flex",
    justifyContent: "center",
    height: "auto",
    transform: "translateX(0px)",
    marginLeft: "0px",
    width: "100%",
  };

  const selectionSettings =
    (Array.isArray(from) || typeof from === "string") && from.includes("Modal")
      ? { mode: "Row", type: "Multiple", persistSelection: true }
      : {};

  const dataSource = new DataManager({
    adaptor: new CustomAdaptor(),
    url: url,
    headers: from ? [{ From: from, HeaderQuery: headerQuery }] : [],
  });

  const handleActionFailure = async (args) => {
    if (args.error && args.error[0]?.error instanceof Response) {
      const response = args.error[0].error;
      try {
        const errorData = await response.json();
        if (response.status === 409) {
          showToast(errorData.detail || errorData.message, t("Error"));
          return;
        }
      } catch (error) {
        console.error("Error parsing response:", error);
      }
    }

    if (
      args.error &&
      args.error.error &&
      args.error.error.status !== undefined
    ) {
      setStatus(args.error.error.status);
    } else {
      setStatus(400);
      showToast(
        `${t("Failed to fetch data. Please try again.")}`,
        `${t("Error")}`
      );
      if (from === "Contacts") {
        showToast(
          `${t("Please check code.It has to be unique.")} <b>${
            args.error[0]?.error?.statusText || ""
          }</b>`,
          `${t("Error")}`
        );
        console.log(args);
      }
    }
  };

  const rowSelected = () => {
    if (grid) {
      const selectedRecords = grid.getSelectedRecords();
      if (onSelectionChange) {
        onSelectionChange(selectedRecords);
      }
    }
  };

  return (
    <>
      <div className="e-adaptive-demo e-bigger" style={divStyle}>
        <div className="e-mobile-layout" style={divStyle}>
          <div className="e-mobile-content" style={divStyle}>
            <GridComponent
              id="adaptivebrowser"
              ref={(g) => (grid = g)}
              dataSource={dataSource}
              selectionSettings={selectionSettings}
              actionFailure={handleActionFailure}
              showColumnChooser={true}
              allowFiltering={true}
              allowSelection={true}
              rowSelected={rowSelected}
              rowDeselected={rowSelected}
              allowPaging={true}
              allowSorting={true}
              allowPdfExport={true}
              allowExcelExport={true}
              editSettings={editSettings}
              actionBegin={actionBegin}
              actionComplete={actionComplete}
              filterSettings={filterSettings}
              sortSettings={sortSettings}
              toolbar={toolbar}
              toolbarClick={toolbarClick}
              contextMenuItems={["Edit", "Delete"]}
              pageSettings={{ pageSize: 50 }}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              width={
                (Array.isArray(from) || typeof from === "string") &&
                from.includes("Modal")
                  ? "100%"
                  : "none"
              }
              //width="none"
              load={load}
              style={{ border: "none", zIndex: "10000000" }}
            >
              <ColumnsDirective>
                {columns.map((col, index) => (
                  <ColumnDirective
                    key={index}
                    field={col.field}
                    headerText={col.headerText}
                    isPrimaryKey={col.isPrimaryKey}
                    visible={col.visible}
                    allowEditing={col.allowEditing}
                    validationRules={col.validationRules}
                    width={col.width}
                    textAlign={
                      isMobile ? "left" : col.textAlign ? col.textAlign : "left"
                    }
                    template={col.template}
                    editTemplate={col.editTemplate}
                    editType={col.editType}
                    displayAsCheckBox={col.isCheckbox}
                    format={col.format}
                    edit={col.edit}
                    filterTemplate={col.filterTemplate}
                  />
                ))}
              </ColumnsDirective>
              <Inject
                services={[
                  Page,
                  Filter,
                  Sort,
                  ColumnChooser,
                  Edit,
                  Toolbar,
                  PdfExport,
                  ExcelExport,
                  ContextMenu,
                ]}
              />
            </GridComponent>
          </div>
        </div>
      </div>
    </>
  );
};
export default Datagrid;
